import { RichtextStoryblok } from "../../../../types/storyblok"

export type Props = {
  name: string,
  expiresAt: string,
  content: RichtextStoryblok
}

export enum AnnouncementStates {
  Dismissed = "dismissed",
  NotDismissed = "notDismissed"
}

export type Status = {
  state: AnnouncementStates,
  expiresAt: string
}
